const OutlineChevronUpDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
      <path
        stroke="#8F6645"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M6.875 12.5 10 15.625l3.125-3.125m-6.25-5L10 4.375 13.125 7.5"
      />
    </svg>
  );
};

export default OutlineChevronUpDown;
